import React from "react";
import { Box, Button, makeStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import CustomPagination from "../../../../../../Utils/layout/components/CustomPagination/CustomPagination";
import { Search } from "../../../../../../Utils/layout/components/search/Search";
import { toAbsoluteUrl } from "../../../../../../Utils/_helpers";
import { Card, CardBody } from "../../../../../../Utils/_partials/controls";
import { useMultiAudio } from "../../../../../util/audioPlayer";
import { Loader2 } from "../../../../../util/loading";
import { useMobileViewport } from "../../../../../util/mobileViewPort";
import { actions } from "../../../../Dashboard/_redux/dashboardRedux";
import {
  fetchTTSSoundsLists,
  resetSoundsList,
  setCurrentPage,
  setManageSoundsTabIndex,
  setPageSize,
  setSearchQuery,
  setSelectedSounds,
  setSoundListingApiPayload,
} from "../../../state/slices/soundsSlice";
import ManageSoundCreateMobileView from "./ManageSoundCreateMobileView";
import DeleteSoundPopupContent from "./QuickActions/DeleteSoundPopupContent";
import SoundTabContent from "./Sounds";
import SoundsDisclaimer from "./SoundsDisclaimer";
import CreateTTS from "./TTSSound/CreateTTS";
import UploadSounds from "./UploadSound";
import SoundsDialog from "./Utils/Popup/SoundsDialog";

function a11yProps(name, index) {
  return {
    id: `${name}-tab-${index}`,
    "aria-controls": `${name}-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      key={index}
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  tabRoot: {
    borderRadius: "4px",
    color: "#464e5f",
    alignItems: "center",
    minWidth: "130px",
    fontSize: "16px",
    marginRight: "32px",
    paddingLeft: "16px",
    textTransform: "capitalize",
    minHeight: "54px",
    "&.Mui-selected": {
      color: "#2c3687",
      fontWeight: theme.typography.fontWeightMedium,
    },
    [theme.breakpoints.down("md")]: {
      marginRight: 0,
      paddingLeft: 0,
      width: "50%",
      fontSize: "13px",
      "&.Mui-selected": {
        backgroundColor: "transparent",
      },
    },
  },
  tabHeader: {
    borderBottom: "solid 1px #e5eaee",
  },
  indicator: {
    backgroundColor: "#2a308b",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(3),
      backgroundColor: "#443092",
    },
  },
  tabs: {
    alignItems: "center",
    [theme.breakpoints.down("md")]: {},
  },
}));

export const setPayloadForFetchSoundLists = (page, pageSize, currentTab) => {
  let type = "LIb";
  if (currentTab === 1) {
    type = "TTS";
  }
  const payload = {
    limit: pageSize,
    offset: (page - 1) * pageSize,
    type: type,
  };
  return payload;
};

export const downloadSoundFile = (sound) => {
  const url = sound.soundlibobj.soundfile;
  const newTab = window.open(url, '_blank');
  if (!newTab) {
    console.log("Failed to open sound file in a new tab.");
  } else {
    newTab.focus();
  }
};

export const DEAFAULT_PAGESIZE = 10;
const Sounds = () => {
  const classes = useStyles();
  const tabNameList = ["Recorded Sound", "TTS Sound"];
  const dispatch = useDispatch();

  const [openCreateTTSDialog, setopenCreateTTSDialog] = useState(false);
  const [openUploadSoundsDialog, setOpenUploadSoundsDialog] = useState(false);
  const [openDeleteSoundsDialog, setOpenDeleteSoundsDialog] = useState(false);
  const [soundFileUrls, setSoundFileUrls] = useState([]);
  const [soundFilesListWithCurrentDuration, setSoundFilesList] = useState([]);

  const isMobileView = useMobileViewport();

  const [
    soundFiles,
    togglePlayAndPause,
    soundFilesPausedDuration,
    handleStopAudio,
  ] = useMultiAudio(soundFileUrls);

  const selectedManageSoundTab = useSelector(
    (state) => state.soundsSlice.activeSoundTab
  );

  const { pageSize, currentPage, soundListingsPayload } = useSelector(
    (state) => state.soundsSlice
  );

  const searchQuery = useSelector((state) => state.soundsSlice.searchQuery);

  const sounds = useSelector((state) => state.soundsSlice.soundList, [
    shallowEqual,
  ]);

  const soundsMetaData = useSelector(
    (state) => state.soundsSlice.soundListMetaData
  );

  const calcNoOfPagesAndRecords = () => {
    const totalCount = soundsMetaData?.total_count || 0;
    if (totalCount)
      return {
        total_entries: totalCount,
        total_pages: Math.ceil(totalCount / pageSize),
      };
    return {};
  };

  const selectedSounds = useSelector(
    (state) => state.soundsSlice.selectedSounds
  );

  useEffect(() => {
    if (sounds.length) {
      setSoundFileUrls(
        sounds.map((sound) => {
          return { url: sound.soundlibobj.soundfile, id: sound.id };
        })
      );
    } else {
      setSoundFileUrls([]);
    }
  }, [JSON.stringify(sounds), selectedManageSoundTab]);

  useEffect(() => {
    let soundsList = soundFiles.map((item, i) =>
      Object.assign({}, item, soundFilesPausedDuration[i])
    );
    setSoundFilesList(soundsList);
  }, [JSON.stringify(soundFilesPausedDuration)]);

  useEffect(() => {
    dispatch(setSearchQuery(null));
  }, [selectedManageSoundTab]);

  useEffect(() => {
    return () => {
      dispatch(setManageSoundsTabIndex(0));
    };
  }, []);

  useEffect(() => {
    if (!searchQuery) {
      getSoundList(currentPage, pageSize, true);
    }
  }, [searchQuery, selectedManageSoundTab, currentPage, pageSize]);

  const getSoundsWithSearch = (
    sizeOfPage = pageSize,
    page = 1
  ) => {
    resetSounds();
    dispatch(
      actions.setLoadingState({
        resource: "sound_lists",
        loading_state: "loading",
      })
    );

    let payload = setPayloadForFetchSoundLists(
      page,
      sizeOfPage,
      selectedManageSoundTab
    );
    payload = {
      ...payload,
      soundlibobj__soundname__icontains: searchQuery,
      ...calcNoOfPagesAndRecords(),
    };

    dispatch(fetchTTSSoundsLists(payload));
  };

  useEffect(() => {
    if (searchQuery !== null) {
      const debounce = setTimeout(() => {
        getSoundsWithSearch();
      }, 1500);
      return () => clearTimeout(debounce);
    }
  }, [searchQuery]);

  const resetSounds = () => {
    dispatch(setSelectedSounds([]));
    setSoundFileUrls([]);
    dispatch(resetSoundsList());
  };

  const getSoundList = (
    page,
    pageSize,
    calcPagesAndTotalPayload = true,
    type = selectedManageSoundTab
  ) => {
    dispatch(
      actions.setLoadingState({
        resource: "sound_lists",
        loading_state: "loading",
      })
    );

    let payload = setPayloadForFetchSoundLists(page, pageSize, type);

    if (soundListingsPayload) {
      payload = {
        ...soundListingsPayload,
      };
      dispatch(setSoundListingApiPayload(null));
    } else {
      payload = {
        ...payload,
        ...(calcPagesAndTotalPayload && calcNoOfPagesAndRecords()),
      };
    }
    dispatch(fetchTTSSoundsLists(payload));
  };

  const handleCreateTTS = () => {
    setopenCreateTTSDialog(true);
  };

  const handleCloseCreateTTS = () => {
    setopenCreateTTSDialog(false);
  };

  const handleUploadSoundsDialog = () => {
    setOpenUploadSoundsDialog(true);
  };

  const handleCloseUploadSounds = () => {
    setOpenUploadSoundsDialog(false);
  };

  const handleSearchInput = (event) => {
    dispatch(setSearchQuery(event.target.value));
  };

  const handleOnTabChange = (event, newValue) => {
    if (newValue !== selectedManageSoundTab) {
      resetSounds();
      dispatch(setSearchQuery(null));
      dispatch(setPageSize(DEAFAULT_PAGESIZE));
      dispatch(setCurrentPage(1));
      dispatch(setManageSoundsTabIndex(newValue));
    }
  };

  const onPageSizeAndPageChange = (pageSize, newPage) => {
    dispatch(setPageSize(pageSize));
    dispatch(setCurrentPage(newPage));
    if (searchQuery !== null) {
      getSoundsWithSearch(pageSize, newPage);
    }
  };

  const handleDownloadSelectedSounds = () => {
    selectedSounds.forEach((soundObj) => {
      downloadSoundFile(soundObj);
    });
    dispatch(setSelectedSounds([]));
  };

  const handleCloseDeletePopup = () => {
    setOpenDeleteSoundsDialog(false);
  };

  const handleOpenDeletePopup = () => {
    setOpenDeleteSoundsDialog(true);
  };
  return (
    <div>
      <div className="row dash-title-row">
        <div className="col-auto mr-auto pr-2 pl-5 mb-3">
          <span className="title-text" style={{ fontSize: "18px" }}>
            <FormattedMessage
              id="manage-sound"
              defaultMessage="Manage Sounds"
            />
          </span>
        </div>
        <div>
          {isMobileView ? (
            <ManageSoundCreateMobileView
              handleCreateTTS={handleCreateTTS}
              handleUploadSoundsDialog={handleUploadSoundsDialog}
            />
          ) : (
            <>
              <Button
                onClick={handleCreateTTS}
                className="sr-btn ml-2 p-3 mr-3  text-capitalize create-phonebook-btn"
              >
                Create TTS
              </Button>

              <Button
                onClick={handleUploadSoundsDialog}
                className="sr-btn ml-2 p-3 mr-3  text-capitalize create-phonebook-btn"
              >
                Upload Sound
              </Button>
            </>
          )}

          <CreateTTS
            openCreateTTSDialog={openCreateTTSDialog}
            handleCloseCreateTTS={handleCloseCreateTTS}
            getSoundList={getSoundList}
          />

          <UploadSounds
            openUploadSoundsDialog={openUploadSoundsDialog}
            handleCloseUploadSounds={handleCloseUploadSounds}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-12 col-lg-12 pl-5 pr-2">
          <Card className="custom-card-style h-100">
            <CardBody className="p-0 pt-2 pb-3">
              <div
                className={`my-3 d-block d-lg-flex justify-content-between  ${clsx(
                  {
                    [classes.tabHeader]: !isMobileView,
                  }
                )}`}
              >
                <Tabs
                  value={selectedManageSoundTab}
                  onChange={handleOnTabChange}
                  TabIndicatorProps={{ className: classes.indicator }}
                  aria-label="sounds-sub"
                  className={`${classes.tabs}   ${clsx({
                    [classes.tabHeader]: isMobileView,
                  })}`}
                >
                  {tabNameList.map((tab, index) => {
                    return (
                      <Tab
                        key={tab}
                        className={classes.tabRoot}
                        label={tab}
                        {...a11yProps(tab, index)}
                      />
                    );
                  })}
                </Tabs>

                <div
                  className={`${clsx("d-flex", {
                    "flex-column mt-5": isMobileView,
                  })} `}
                >
                  <div
                    className={`${clsx({
                      "mr-5 ": !isMobileView,
                      "mx-10": isMobileView,
                    })} `}
                  >
                    <Search
                      value={searchQuery}
                      ariaLabel="Sound"
                      handleSearchInput={handleSearchInput}
                      placeholder="Search Sound"
                      width={isMobileView ? "100%" : 298}
                    />
                  </div>

                  <div
                    className={`${clsx({
                      "mt-5 d-flex justify-content-end  mr-10 mb-n5": isMobileView,
                      "mr-20 ": !isMobileView,
                    })} `}
                  >
                    <img
                      alt="download"
                      src={toAbsoluteUrl(
                        `/media/sr/icons/${
                          selectedSounds.length > 0
                            ? "download-multi-active"
                            : "download-multi-inactive"
                        }.svg`
                      )}
                      className="mr-5"
                      onClick={handleDownloadSelectedSounds}
                      style={{
                        cursor: "pointer",
                        width: "41px",
                        height: "37px",
                        pointerEvents:
                          selectedSounds.length === 0 ? "none" : "auto",
                      }}
                    />
                    {/* <img
                      alt="delete"
                      src={toAbsoluteUrl(
                        `/media/sr/icons/${
                          selectedSounds.length > 0
                            ? "delete-multi-active"
                            : "delete-multi-inactive"
                        }.svg`
                      )}
                      onClick={handleOpenDeletePopup}
                      style={{
                        cursor: "pointer",
                        width: "41px",
                        height: "37px",
                        pointerEvents:
                          selectedSounds.length === 0 ? "none" : "auto",
                      }}
                    /> */}
                  </div>
                </div>
              </div>
              <Loader2 resource="sound_lists" />

              <TabPanel value={selectedManageSoundTab} index={0}>
                <SoundTabContent
                  key={selectedManageSoundTab}
                  togglePlayAndPause={togglePlayAndPause}
                  sounds={sounds}
                  soundFileList={soundFiles}
                  soundFilesPausedDuration={soundFilesPausedDuration}
                  handleStopAudio={handleStopAudio}
                />
              </TabPanel>
              <TabPanel value={selectedManageSoundTab} index={1}>
                <SoundTabContent
                  key={selectedManageSoundTab}
                  togglePlayAndPause={togglePlayAndPause}
                  sounds={sounds}
                  soundFileList={soundFiles}
                  soundFilesPausedDuration={soundFilesPausedDuration}
                  handleStopAudio={handleStopAudio}
                />
              </TabPanel>
              <CustomPagination
                key={selectedManageSoundTab}
                onPageSizeAndPageChange={onPageSizeAndPageChange}
                totatCount={soundsMetaData?.total_count}
              />
            </CardBody>
          </Card>
        </div>
      </div>

      <SoundsDialog
        open={openDeleteSoundsDialog}
        handleClose={() => handleCloseDeletePopup()}
        maxWidth="lg"
        title=""
      >
        <DeleteSoundPopupContent
          sound={null}
          selectedSoundList={selectedSounds}
          handleCloseDeletePopup={handleCloseDeletePopup}
        />
      </SoundsDialog>
      <SoundsDisclaimer />
    </div>
  );
};

export default Sounds;
